import CustomButton from "../Shared/Button";

const ErrorPage = () => {
  const handleReload = () => {
    window.location.href = "/";
  };

  return (
    <div className="w-full h-[100vh] flex items-center justify-center">
      <div className="flex items-center flex-col">
        <p className="text-[32px] font-bold mb-[4px]">Oops!</p>
        <p className="mb-12">Something wrong happened, sorry for that!</p>

        <CustomButton onClick={handleReload} type="primary" size="small">
          Go home
        </CustomButton>
      </div>
    </div>
  );
};

export default ErrorPage;
